import { Check, CheckLine } from "lucide-react";
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer,
  CartesianGrid,
  Legend
} from "recharts";

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-white border p-2 rounded shadow text-sm">
        <p className="font-medium capitalize">{label}</p>
        <p className="text-green-800">
          <span className="font-semibold">Total Area:</span> {payload[0].value + payload[1].value} Acres
        </p>
        <p className="text-yellow-800">
          <span className="font-semibold">Sprayed Area:</span> {payload[1].value} Acres
        </p>
      </div>
    );
  }

  return null;
};
const CustomLabel = () => {
  return (
    <div className="flex justify-center gap-6 px-4 text-sm">
      {/* Area Covered (striped box) */}
      <div className="flex items-center gap-2">
        <div
          className="w-4 h-4 rounded-sm"
          style={{
            backgroundColor: '#e9fffaff', // light blue base
            backgroundImage: `repeating-linear-gradient(
              45deg,
              #568203,
              #568203 2px,
              transparent 2px,
              transparent 6px
            )`
          }}
        />
        <span className="text-gray-700">Area Covered (Unsprayed)</span>
      </div>

      {/* Sprayed Area (solid green) */}
      <div className="flex items-center gap-2">
        <div className="w-4 h-4 rounded-sm bg-[#568203]" />
        <span className="text-gray-700">Sprayed Area</span>
      </div>
    </div>
  );
};

export default function BarChartRender({combinedData, filter}) {

  // state wise area covered
	const stateWiseArea = combinedData.reduce((acc, curr) => {
		if (!acc[curr.state]) {
			acc[curr.state] = 0;
		}
		acc[curr.state] += curr.area || 0;
		return acc;
	}, {});

	// state wise area sprayed

	const stateWiseSprayed = combinedData.reduce((acc, curr) => {
		if (!acc[curr.state]) {	
			acc[curr.state] = 0;
		}
		acc[curr.state] += curr.areaSprayed || 0;
		return acc;
	}, {});

  const data = Object.keys(stateWiseArea).map((state) => ({
    name: state,
    areaCovered: Math.floor(stateWiseArea[state]-stateWiseSprayed[state]) || 0,
    sprayData: Math.floor(stateWiseSprayed[state]) || 0,
  }));

  return (
    <div className="bg-white mt-2 p-4 rounded-xl shadow md:w-[65%] w-[100%]">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h2 className="text-lg font-semibold text-gray-800">State-wise Area Sprayed</h2>
          <p className="text-sm text-gray-500">Total area sprayed in each state is shown in the bar graph.</p>
        </div>
        <div>
          <select className="border p-2 outline-none" onChange={(event) => filter(event.target.value)}>
            <option value={'all'}>All</option>
            <option value={'last-month'}>Last 30 days</option>
            <option value={'last-week'}>Last 7 days</option>
          </select>
        </div>
      </div>
      

      <ResponsiveContainer width="100%" height={300}>
        <BarChart
          width={500}
          height={300}
          data={data}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5,
          }}
          barSize={120} 
        >
          <defs>
            <pattern id="stripedBlue" patternUnits="userSpaceOnUse" width="6" height="6" patternTransform="rotate(45)">
               <rect x="0" y="0" width="6" height="6" fill="#e9fffaff" />  {/* light blue base */}
              <rect width="2" height="6" transform="translate(0,0)" fill="#568203" />
            </pattern>
          </defs>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip content={<CustomTooltip/>} />
          <Legend content={<CustomLabel/>} />
          <Bar dataKey="areaCovered" stackId="a" fill="url(#stripedBlue)" radius={[0,0,0,0]}  />
          <Bar dataKey="sprayData" stackId="a" fill="#568203" radius={[30,30,0,0]}  />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
